export default {"src":"/_next/static/media/rate.d5325fa6.svg","height":24,"width":25};